import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  terminalType: null,
};

const terminalSlice = createSlice({
  name: 'terminal',
  initialState,
  reducers: {
    setTerminalType: (state, action) => {
      state.terminalType = action.payload.terminalType;
    },
    clearTerminal: (state) => {
      const oneHour = 60 * 1000;
      const now = Date.now();
      const timestamp = new Date().getTime();

      if (now - timestamp > oneHour) {
        state.terminalType = null;
      }
    },
  },
});

export const { setTerminalType, clearTerminal } = terminalSlice.actions;

export default terminalSlice.reducer;
